import { useEffect } from "react";

import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $setSelection, CLEAR_HISTORY_COMMAND } from "lexical";

import htmlText from "utils/htmlToText";

export default function InitialValuePlugin({
  htmlString,
}: {
  htmlString?: string;
}) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (!htmlString) return;
    if (!htmlText(htmlString)?.trim()) return;

    editor.update(() => {
      const parser = new DOMParser();
      const dom = parser.parseFromString(htmlString, "text/html");

      const nodes = $generateNodesFromDOM(editor, dom);

      const root = $getRoot();
      root.clear();
      root.append(...nodes);
      $setSelection(null);

      editor.dispatchCommand(CLEAR_HISTORY_COMMAND, void 0);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}
